export default {
  $_veeValidate: {
    validator: 'new'
  },

  methods: {
    validate () {
      return this.$validator.validateAll()
    }
  }
}
